<div class="pre-login-wrap register-page">
  <div class="left-block" [ngClass]="{'step-0-background': currentImagePath === 0,
  'step-1-background': currentImagePath === 1,
  'step-2-background': currentImagePath === 2}">
    <div class="left-content-wrapper">
      <h1>Delm8 Corporate Cloud</h1>
      <h2>
        Start your 14-days <br />
        free trial today
      </h2>
      <div class="feature-list">
        <span *ngIf="currentImagePath == 0" class="inner-title">With Delm8 you will get:</span>
        <ul>
          <li *ngFor="let feature of featureLists[currentImagePath]">
            <mat-icon>check_circle</mat-icon>
            <div [innerHtml]="feature"></div>
          </li>
        </ul>
        <span *ngIf="currentImagePath == 2" class="terms-conditions">*Terms and conditions apply</span>
      </div>
    </div>
    <div class="bottom-bg">
      <img *ngIf="currentImagePath === 0" src="/assets/images/icons/registration1.svg" alt="">
      <img *ngIf="currentImagePath === 1" src="/assets/images/icons/courier_boy.png" alt="">
      <img *ngIf="currentImagePath === 2" src="/assets/images/icons/step-3.png" alt="">
    </div>
  </div>
  <div class="right-block">
    <div class="form-wrapper">
      <mat-stepper linear (selectionChange)="onStepChange($event.selectedIndex)" #stepper>
        <mat-step label="Company Info" [stepControl]="companyDetailFormGroup">
          <app-company-detail-form #companyDetailFormComponent></app-company-detail-form>
        </mat-step>
        <mat-step label="Select Plan" [stepControl]="planSelectionFormGroup">
          <app-plan-selection-form #planSelectionFormComponent></app-plan-selection-form>
        </mat-step>
        <mat-step label="Start Trial" [stepControl]="paymentFormGroup">
          <app-payment-form (buttonClick)="registerUser($event)" #paymentFormComponent></app-payment-form>
        </mat-step>
      </mat-stepper>
    </div>
  </div>
</div>
